// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"0fcd11fa","219":"0e3e635c","304":"3f9f8242","378":"c8935edd","532":"5207cdc4","652":"2caa4eb6","776":"a9e90a4e"}[chunkId] + ".chunk.js";
};